// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__18hai","productName":"Table_productName__3oeVy"};